import React from "react";
import Error from "../components/Error/Error";

const ErrorPage = () => {
  return (
    <div>
      <Error />
    </div>
  );
};

export default ErrorPage;
